export const invalidTokenError = (error?: string | null) =>
  !!error?.includes('Token is invalid');
